import './PrivacyPolicyPage.scss';

export const PrivacyPolicyPage = () => {
  return (
    <main className="privacy-policy-page">
      <section className="privacy-policy-page__content" aria-labelledby="privacy-policy-title">
        <p className="privacy-policy-page__brand">Dovery</p>
        <h1 id="privacy-policy-title" className="privacy-policy-page__title">Privacy Policy</h1>
        <p className="privacy-policy-page__updated">Last Updated: June 1, 2026</p>

        <h2>Introduction</h2>
        <p>
          Welcome to Dovery (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;). We respect your privacy and are
          committed to protecting your personal information. This Privacy Policy explains how we
          collect, use, store, and delete your information when you use our application and services.
        </p>
        <p>
          By using our application, you agree to the practices described in this Privacy Policy.
        </p>

        <h2>Information We Process</h2>
        <h3>Account Information</h3>
        <p>When you sign in, we may receive:</p>
        <ul>
          <li>Your name</li>
          <li>Email address</li>
          <li>Google account identifier, if Google sign in used</li>
          <li>Profile picture, if provided by Google</li>
        </ul>
        <p>We do not receive, store, or have access to your account password.</p>

        <h3>User Content</h3>
        <p>When you use our services, you may provide:</p>
        <ul>
          <li>Images uploaded for display purposes</li>
          <li>Device and display configuration settings</li>
          <li>Application preferences and settings</li>
        </ul>

        <h3>Technical Information</h3>
        <p>We may collect limited technical information necessary to provide the service, including:</p>
        <ul>
          <li>Device information</li>
          <li>Application usage data</li>
          <li>Error and diagnostic logs</li>
          <li>Display device configuration information</li>
        </ul>

        <h2>How We Use Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Create and manage your account</li>
          <li>Authenticate your identity</li>
          <li>Deliver images to connected displays</li>
          <li>Store display settings and preferences</li>
          <li>Improve application performance and reliability</li>
          <li>Provide customer support</li>
        </ul>

        <h2>Image Storage</h2>
        <h3>Display Images</h3>
        <p>
          Images that you send to displays are stored to enable display functionality. These images,
          including any generated display binaries, are automatically removed when they are no longer
          associated with any active display device.
        </p>

        <h2>Data Retention</h2>
        <p>
          We retain information only for as long as necessary to provide our services.
        </p>
        <p>Data may include:</p>
        <ul>
          <li>Account information</li>
          <li>User-uploaded images</li>
          <li>Display binaries</li>
          <li>Device settings</li>
          <li>User preferences</li>
        </ul>
        <p>When content is no longer needed for active services, it may be automatically removed.</p>

        <h2>Account Deletion and Data Removal</h2>
        <p>You may request account deletion at any time through the application or by contacting us.</p>
        <p>Upon deletion of your account:</p>
        <ul>
          <li>Your account information will be removed.</li>
          <li>Your device settings and preferences will be removed.</li>
          <li>Your uploaded images will be removed.</li>
          <li>Your display binaries will be removed.</li>
        </ul>
        <p>
          Data associated with your account will be permanently deleted, except where retention is
          required by law or necessary for security, fraud prevention, or legal compliance.
        </p>

        <h2>Data Security</h2>
        <p>
          We implement reasonable administrative, technical, and organizational measures designed to
          protect your information from unauthorized access, disclosure, alteration, or destruction.
        </p>
        <p>
          However, no method of electronic storage or transmission over the Internet can be guaranteed
          to be 100% secure.
        </p>

        <h2>Children&apos;s Privacy</h2>
        <p>
          Our services are not directed toward children under the age required by applicable law. We do
          not knowingly collect personal information from children without appropriate consent.
        </p>

        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any updates will be posted on this page
          with a revised &quot;Last Updated&quot; date.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions regarding this Privacy Policy, please contact us at:
        </p>
        <ul>
          <li>Email: support@doveryTech.com</li>
          <li>Website: https://dovery.com</li>
        </ul>
      </section>
    </main>
  );
};
